import PartnerConstant from 'Shared/Constants/PartnerConstant';

const debounce: (fn: () => void, delay?: number) => any = (fn, delay) => {
  return setTimeout(() => {
    fn();
  }, delay || PartnerConstant.debounce_Interval);
};

export default debounce;
